import { render, staticRenderFns } from "./RentObjectsAdminSort.vue?vue&type=template&id=45702aff&scoped=true&lang=pug"
import script from "./RentObjectsAdminSort.vue?vue&type=script&lang=js"
export * from "./RentObjectsAdminSort.vue?vue&type=script&lang=js"
import style0 from "./RentObjectsAdminSort.vue?vue&type=style&index=0&id=45702aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45702aff",
  null
  
)

export default component.exports